import React, { Component } from 'react'
import { connect } from 'react-redux'

import '@/assets/styles/components/VirtualTrading/VirtualTradingRightDetail/virtual-trading-area.scss'
import hk from '@/assets/images/icons/bottom_icon_hk.png'



import Dropdown from '@/components/Dropdown/Dropdown';
import VirtualTradingAreaLeft from './VirtualTradingArea/VirtualTradingAreaLeft'
import VirtualTradingAreaRight from './VirtualTradingArea/VirtualTradingAreaRight'
import VirtualTradingAreaBottom from './VirtualTradingArea/VirtualTradingAreaBottom'

class VirtualTradingArea extends Component {
    render() {
        const { language } = this.props
        return (
            <div className='virtual-trading-area' >
                <div className='vta-head'>
                    <div className='vta-head-img' ><img src={hk} /></div>
                    <Dropdown />
                    <span>{language.virtual_trading_portfolio_market_value + ':'}</span>
                    <span>{language.portfolio_float_PL + ':'}</span>
                    <span>{language.portfolio_float_PL_percent + ':'}</span>
                </div>
                <div className='vta-centent'>
                    <VirtualTradingAreaLeft/>
                    <VirtualTradingAreaRight/>
                </div>
                <div className='vta-bottom' >
                    <VirtualTradingAreaBottom/>
                </div>
            </div>
        )
    }
}

export default connect(state => ({
    language: state.app.language,
}),
    dispatch => ({

    }))(VirtualTradingArea)
